import prefixedRoute from './utils/prefixed-route'

export const BABYLIST_URL = '//www.babylist.com'
export const CUSTOMER_INFORMATION_PATH = prefixedRoute(
  '/dme-customer-information'
)
export const DME_ZENDESK_URL = '//healthbabylist.zendesk.com/hc/en-us'
export const DME_RETURN_POLICY_URL =
  'https://healthbabylist.zendesk.com/hc/en-us/articles/12903014268443'
export const GUIDES_PATH = '/hello-baby'
export const HOME_PATH = prefixedRoute('/')
export const HEALTH_CONTACT_EMAIL = 'health@babylist.com'
export const HEALTH_RX_EMAIL = 'rx@babylist.com'
export const SEARCH_PHYSICIAN_PATH = `${CUSTOMER_INFORMATION_PATH}/search-physician`
export const STORE_PATH = prefixedRoute('/dme-store')
export const PRIVACY_URL = 'https://www.babylist.com/privacy'
export const TERMS_AND_CONDITIONS_PATH = '/terms'
export const INSURANCE_PARTNER_PATH = prefixedRoute('/insurancepartners')
export const STORE_NAME = 'Babylist Health'
// The storkpump link is currently not working. Keeping it here for now, but may need to remove if we don't use it
export const STORK_PUMP_REFERRAL_URL =
  'https://pcs.adapthealth.com/breast-pump-program-babylist-health'
export const EDGEPARK_REFERRAL_URL = 'https://edgepark.sjv.io/b3YDvk'
export const PHYSICIAN_RESULT_PATH = `${SEARCH_PHYSICIAN_PATH}/results`
export const PATIENT_TO_CHECKOUT_PATH = `${PHYSICIAN_RESULT_PATH}/checkout`
export const ORDER_PATH = prefixedRoute('/orders/:id')

export const REPLACEMENT_PARTS_PATH = prefixedRoute(
  '/orders/:id/replacement-parts'
)
export const PDP_PATH = prefixedRoute('/gp/:urlSlug/:id/:productId')
export const SUBSCRIPTIONS_PATH = '/health/subscriptions/:id'

export const PUMP_PARTS_STORE_PAGE_URL =
  'https://www.babylist.com/store/pumping-parts-and-accessories'
